import { render, staticRenderFns } from "./zoneChannelsInfo.vue?vue&type=template&id=66780639&scoped=true&"
import script from "./zoneChannelsInfo.vue?vue&type=script&lang=js&"
export * from "./zoneChannelsInfo.vue?vue&type=script&lang=js&"
import style0 from "./zoneChannelsInfo.vue?vue&type=style&index=0&id=66780639&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66780639",
  null
  
)

export default component.exports